import { render } from "./bank-settings.vue?vue&type=template&id=3d8e9da6"
import script from "./bank-settings.vue?vue&type=script&lang=js"
export * from "./bank-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__